/* eslint-disable @typescript-eslint/no-floating-promises */
import React from 'react';
import { fetchDelete, fetchGet, fetchPost } from '../../store/fetch';
import { Content, Panel, PanelBody, PanelHorizontalSpacing, Tray } from '../elements';
import { IAsset } from '../interfaces/IAsset';
import { AssetDropzone } from '../Surveys/Common/AssetDropzone';
import { DocumentsList } from '../utils/DocumentsList';
import { useReactAsync } from '../utils/useReactAsync';
import { TopBar } from './Common/TopBar';

async function loadAssets({ batchId }: { batchId: string }) {
    const url = `/api/batches/${batchId}/assets`;
    const result = await fetchGet(url);
    return result.json as IAsset[];
}

export function BatchDocuments(props: { params: { id?: string } }) {
    const batchId = props.params.id;
    if (!batchId) {
        throw new Error('id is required in query params');
    }
    const { data, reload } = useReactAsync(loadAssets, { batchId }, []);

    const removeDocument = async (assetId: string) => {
        const url = `/api/batches/${batchId}/assets/${assetId}`;
        await fetchDelete(url);
        await reload();
    };

    const updateDocument = async (assetId: string, payload: Record<string, unknown>) => {
        const url = `/api/batches/${batchId}/assets/${assetId}`;
        await fetchPost(url, {}, payload);
        await reload();
    };

    return (
        <>
            <TopBar batchId={batchId} activeTab="documents" />
            <Content>
                <Tray>
                    <Panel>
                        <PanelBody>
                            <PanelHorizontalSpacing>
                                <AssetDropzone
                                    acceptedFiles=".png,.jpeg,.jpg,.pdf,.doc,.docx,.zip"
                                    onComplete={reload}
                                    batchId={batchId}
                                    autoProcessQueue={true}
                                />
                            </PanelHorizontalSpacing>
                            <PanelBody noPadding={true}>
                                {data && (
                                    <DocumentsList
                                        assets={data}
                                        blueHeader={true}
                                        onRemove={async (assetId: string) => removeDocument(assetId)}
                                        onUpdate={updateDocument}
                                    />
                                )}
                            </PanelBody>
                        </PanelBody>
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
